/**
 * Each action represents a GA event's with category, label, and action name
 */
export const events = {
  bypass_login: {
    action: 'bypass_login',
    category: 'lost_app',
    label: 'login_and_trust_ok',
  },
  assistance: {
    action: 'clic_assistance',
    category: 'lost_app',
    label: 'picto_assistance',
  },
  // Step 1 - Login events
  login: {
    action: 'clic_continuer_login',
    category: 'lost_login',
    label: 'bouton_login_continuer',
  },
  helpLogin: {
    action: 'clic_help_login',
    category: 'lost_login',
    label: 'picto_help_login',
  },
  HelpNsru: {
    action: 'clic_consigne_nsru',
    category: 'lost_login',
    label: 'picto_consigne_NSRU',
  },
  endNsru: {
    action: 'clic_terminer_nsru',
    category: 'lost_login',
    label: 'bouton_login_terminer_NSRU',
  },
  loginInvalid: {
    action: 'clic_continuer_login',
    category: 'lost_login',
    label: 'erreur_mail_invalide',
  },
  loginUnknown: {
    action: 'clic_continuer_login',
    category: 'lost_login',
    label: 'erreur_mail_inconnu',
  },
  captchaUnfinished: {
    action: 'clic_continuer_login',
    category: 'lost_login',
    label: 'erreur_captcha_non_fini',
  },
  captchaInvalid: {
    action: 'clic_continuer_login',
    category: 'lost_login',
    label: 'erreur_captcha_invalide',
  },
  findLogin: {
    action: 'clic_retrouver_mail',
    category: 'lost_login',
    label: 'lien_retrouver_mail',
  },
  // Step 2 - Contact choice events
  helpCanal: {
    action: 'clic_help_canal',
    category: 'lost_canal',
    label: 'picto_canal_help',
  },
  resetByMail: {
    action: 'clic_canal_mail',
    category: 'lost_canal',
    label: 'chevron_canal_mail',
  },
  resetBySms: {
    action: 'clic_canal_sms',
    category: 'lost_canal',
    label: 'chevron_canal_sms',
  },
  noContactLink: {
    action: 'clic_lien_nocontact',
    category: 'lost_canal',
    label: 'lien_canal_aucun_contact',
  },
  endNoContact: {
    action: 'clic_terminer_aucun_contact',
    category: 'lost_canal',
    label: 'bouton_terminer_aucun_contact',
  },
  getLetter: {
    action: 'clic_recevoir_courrier',
    category: 'lost_canal',
    label: 'bouton_recevoir_courrier',
  },
  useTemporaryPassword: {
    action: 'clic_saisie_mot_de_passe_provisoire',
    category: 'lost_canal',
    label: 'lien_saisie_mot_de_passe_provisoire',
  },
  multibalCannotUseContact: {
    action: 'clic_bouton_retour',
    category: 'lost_canal',
    label: 'lien_retour',
  },
  // Step 2 - Default contact events
  defaultContactListLink: {
    action: 'clic_toutes_methodes',
    category: 'lost_contact_defaut',
    label: 'lien_toutes_methodes',
  },
  defaultContactOtcSms: {
    action: 'clic_otc_sms',
    category: 'lost_contact_defaut',
    label: 'bouton_otc_sms',
  },
  // Step 2 - Letter choice events
  helpPostalCode: {
    action: 'clic_help_code_reinit',
    category: 'lost_courrier',
    label: 'lien_help_code_reinit',
  },
  sendLetter: {
    action: 'clic_valider_codepostal',
    category: 'lost_courrier',
    label: 'bouton_valider_codepostal',
  },
  endLetter: {
    action: 'clic_envoi_courrier_terminer',
    category: 'lost_courrier',
    label: 'bouton_terminer_envoi',
  },
  // Step 3 - One time code events
  helpOtc: {
    action: 'clic_help_code',
    category: 'lost_code',
    label: 'picto_help_code',
  },
  retryCode: {
    action: 'clic_renvoi_code',
    category: 'lost_code',
    label: 'bouton_code_renvoi',
  },
  checkCode: {
    action: 'clic_continuer_code',
    category: 'lost_code',
    label: 'bouton_code_continuer',
  },
  otpContactListLink: {
    action: 'clic_toutes_methodes',
    category: 'lost_code',
    label: 'lien_toutes_methodes',
  },
  // Step 4 - Update password events
  helpPassword: {
    action: 'clic_help_pwd',
    category: 'lost_password',
    label: 'picto_pwd_help',
  },
  showPassword: {
    action: 'clic_affich_pwd_crea',
    category: 'lost_password',
    label: 'picto_pwd_crea_afficher',
  },
  showPasswordConfirm: {
    action: 'clic_affich_pwd_confirm',
    category: 'lost_password',
    label: 'picto_pwd_confirm_afficher',
  },
  updatePassword: {
    action: 'clic_valider_pwd',
    category: 'lost_password',
    label: 'pwd_valider',
  },
  // Step 5 - Add contacts events
  checkedNoMail: {
    action: 'clic_valider',
    category: 'lost_add_contact',
    label: 'aucun_mail',
  },
  checkedNoMobile: {
    action: 'clic_valider',
    category: 'lost_add_contact',
    label: 'aucun_mobile',
  },
  checkedBoth: {
    action: 'clic_valider',
    category: 'lost_add_contact',
    label: 'aucun_mail_ni_mobile',
  },
  updateContacts: {
    action: 'clic_valider',
    category: 'lost_add_contact',
    label: 'bouton_valider',
  },
  errorMessageMailDelete: {
    action: 'message_erreur_suppression_mail',
    category: 'lost_add_contact',
    label: 'message_erreur_suppression_mail',
  },
  // Step 6 - Add contacts events
  helpMessaging: {
    action: 'clic_registr_maj_cpte',
    category: 'lost_registration',
    label: 'lien_registr_maj_compte',
  },
  account: {
    action: 'clic_registr_modif_cpte',
    category: 'lost_registration',
    label: 'lien_registr_modif_compte',
  },
  phishingInfo: {
    action: 'clic_registr_phishing',
    category: 'lost_registration',
    label: 'lien_registr_phishing',
  },
  auth: {
    action: 'clic_registr_sidentifier',
    category: 'lost_registration',
    label: 'bouton_registr_sidentifier',
  },
  backToManageBal: {
    action: 'clic_retour_liste_comptes',
    category: 'lost_registration',
    label: 'bouton_retour_liste_comptes',
  },
  closeDialog: {
    action: 'clic_close_popin',
    category: 'lost_registration',
    label: 'bouton_fermer_popin',
  },
  openFeedback: {
    action: 'clic_answer_feedback_button',
    category: 'lost_registration',
    label: 'bouton_repondre_questionnaire',
  },
  // Error page events
  technicalError: {
    action: 'erreur_technique_bloquante',
    category: 'lost_erreur_tech',
    label: 'erreur_tech_bloquante',
  },
  noJavascript: {
    action: 'erreur_technique_java',
    category: 'lost_erreur_tech',
    label: 'erreur_tech_java',
  },
  unlockCompromisedAccount: {
    action: 'clic_debloquer_compte',
    category: 'lost_registration',
    label: 'bouton_debloquer_compte',
  },
};

export const screens = {
  '/ident': 'login',
  '/captcha': 'captcha',
  '/choice': 'canal',
  '/choice/default': 'contact_defaut',
  '/choice/sav': 'contact_sav',
  '/choice/owner': 'contact_titulaire',
  '/letter': 'canal_courrier',
  '/otc': 'code',
  '/password': 'password',
  '/contact': 'ajout_contacts',
  '/confirm': 'registration',
  '/error': 'erreur_technique',
};
